import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-doc-pdf-modal-view',
  templateUrl: './doc-pdf-modal-view.component.html',
  styleUrls: ['./doc-pdf-modal-view.component.css']
})
export class DocPdfModalViewComponent implements OnInit {


  @Input() selectedData: any;
  fileDiscription: any;
  selectedPdf: string;
  file_type: any;
  constructor() { }

  
  ngOnChanges() {
    // $('#pdf-view').modal('show');
      this.file_type = this.selectedData.file_type
      this.fileDiscription = this.selectedData.file_discription;
      this.selectedPdf = this.selectedData.User_Data +'#toolbar=0&navpanes=0&scrollbar=0';
  }
  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/application/core-module/scora-modal-module/doc-pdf-modal-view/doc-pdf-modal-view.component.ts